import { Button } from '../../../../components/Button/Button';
import { useGlobalProviderContext } from '../../../../context/global';
import {
  ProChangePasswordSuccessMessageBlockSubTitle,
  ProChangePasswordSuccessMessageBlockTitle,
  ProChangePasswordSuccessMessageBlockWrapper,
} from './ProChangePasswordSuccessMessageBlock.styles';
import { ProChangePasswordSuccessMessageBlockProps } from './ProChangePasswordSuccessMessageBlock.types';
import { StoryblokComponent } from '@storyblok/react';
import { patchedStoryblokEditable } from '../../../../utils/patchedStoryblokEditable';

export const ProChangePasswordSuccessMessageBlock = (
  props: ProChangePasswordSuccessMessageBlockProps
) => {
  const { blok } = props;
  const { title, subtitle, buttonText = 'Log in' } = blok;

  const globalContext = useGlobalProviderContext();

  return (
    <ProChangePasswordSuccessMessageBlockWrapper {...patchedStoryblokEditable(blok)}>
      {title.length > 0 && (
        <ProChangePasswordSuccessMessageBlockTitle>
          <StoryblokComponent blok={title[0]} />
        </ProChangePasswordSuccessMessageBlockTitle>
      )}

      {subtitle.length > 0 && (
        <ProChangePasswordSuccessMessageBlockSubTitle>
          <StoryblokComponent blok={subtitle[0]} />
        </ProChangePasswordSuccessMessageBlockSubTitle>
      )}

      <Button
        text={buttonText}
        url={globalContext.serviceOSSettings.loginPageUrl}
        variant="filledBlue"
        fullWidth
        shrink
      />
    </ProChangePasswordSuccessMessageBlockWrapper>
  );
};
